import React from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

/**
 * Reusable reason-capture dialog used for both QA-fail and cancel-item flows.
 */
export default function ReasonDialog({ open, action, item, reason, setReason, busy, onSubmit, onClose }) {
  const isQaFail = action === "qa-fail";
  const placeholder = isQaFail
    ? "e.g. Door scratched, paint runs…"
    : "e.g. Customer cancelled this line item";

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-heading">
            {isQaFail ? "Fail QA" : "Cancel item"}
            {item && (
              <span className="font-mono text-base text-zinc-500"> · {item.sku}</span>
            )}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <Label className="text-xs uppercase tracking-[0.2em] font-semibold">
            Reason (required)
          </Label>
          <Textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={3}
            placeholder={placeholder}
            data-testid="reason-textarea"
          />
        </div>
        <DialogFooter>
          <Button
            onClick={onSubmit}
            disabled={!reason.trim() || busy}
            className="bg-[#C8102E] hover:bg-[#A00D25]"
            data-testid="submit-reason"
          >
            Submit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
